var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17.760712,
    viewBox: "0 0 16 17.760712",
    fill: "none",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 6.8453123,0.3094018 c 0.7145299,-0.41253573 1.5948752,-0.41253573 2.3094052,0 L 14.845297,3.5948757 C 15.559879,4.0074073 16,4.7698087 16,5.5948822 v 6.5709868 c 0,0.825022 -0.440121,1.587434 -1.154703,1.999945 l -5.6905795,3.285514 c -0.71453,0.412511 -1.5948753,0.412511 -2.3094052,0 L 1.1547016,14.165814 C 0.44017059,13.753303 0,12.990891 0,12.165869 V 5.5948822 C 0,4.7698087 0.44017059,4.0074073 1.1547016,3.5948757 Z",
    fill: "currentColor",
    id: "path1",
    style: {
      strokeWidth: 1.0264
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.d298b8539ccbc853e257b7ab74f6a6ca.svg";
export { ForwardRef as ReactComponent };